export default __webpack_public_path__ + "static/media/im.685ca372.svg";